// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_API_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
let app;
let messaging;

try {
  if (process.env.REACT_APP_PROJECT_ID) {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  } else {
    console.warn('Firebase config missing projectId - Firebase features disabled');
  }
} catch (error) {
  console.warn('Firebase initialization failed:', error);
}

// let messaging = null;
// if (isSupported()) {
//   messaging = getMessaging();
// }

// const messaging = (async () => {
//   try {
//     const isSupportedBrowser = await isSupported();
//     if (isSupportedBrowser) {
//       return getMessaging();
//     }
//     console.log("Firebase not supported this browser");
//     return null;
//   } catch (err) {
//     console.log(err);
//     return null;
//   }
// })();
// onMessage(messaging, (payload) => {
//     console.log('Message received. ', payload);
//     // ...
// });
function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          //   console.log("Service worker registered:", registration);
        })
        .catch((error) => {
          //   console.log("Service worker registration failed:", error);
        });
    });
  }
}

const onMessageListener = () =>
  new Promise((resolve) => {
    if (messaging) {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    } else {
      resolve(null);
    }
  });

export { app, messaging, onMessageListener, register };
